import type { Fact, RequestDetail } from "@/api";
import type { TFunc } from "../../i18n";
import { isEmptyVal, valToStr } from "../fact-value";
import { reviewMessageEntries } from "./model";

function factVal(facts: Fact[], path: string): unknown {
  return facts.find((fact) => fact.fieldPath === path)?.value ?? null;
}

export function workspaceCorrespondence(
  facts: Fact[],
  messages: RequestDetail["messages"],
  t: TFunc,
) {
  const messagesNewestFirst = reviewMessageEntries(messages).map(({ message }) => message);
  const latestInbound = messagesNewestFirst.find((message) => message.direction === "inbound") ?? null;
  const latestOutbound = messagesNewestFirst.find((message) => message.direction === "outbound") ?? null;
  const companyRaw = factVal(facts, "customer.company_name");
  const contactRaw = factVal(facts, "customer.contact_name");
  const company = !isEmptyVal(companyRaw)
    ? valToStr(companyRaw, t)
    : !isEmptyVal(contactRaw)
      ? valToStr(contactRaw, t)
      : (messages.find((message) => message.direction === "inbound")?.fromAddr || t("ws.requestTitleFallback"));
  const requestSubject = latestInbound?.subject?.trim()
    || messagesNewestFirst.find((message) => message.subject?.trim())?.subject?.trim()
    || null;
  const draftSender = latestOutbound?.fromAddr
    || latestInbound?.toAddrs?.find(Boolean)
    || t("common.noInfo");
  const draftRecipient = latestOutbound?.toAddrs?.find(Boolean)
    || latestInbound?.fromAddr
    || t("common.noInfo");
  return { company, requestSubject, draftSender, draftRecipient };
}
